/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Qr_Account_HolderInputs */

const vi_payment_qr_account_holder = /** @type {(inputs: Payment_Qr_Account_HolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chủ tài khoản`)
};

/**

* @param {Payment_Qr_Account_HolderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const payment_qr_account_holder = /** @type {((inputs?: Payment_Qr_Account_HolderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Qr_Account_HolderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_payment_qr_account_holder(inputs)
});